import angular from 'angular'
import routers from './routers'
import fieldConfig from './fieldConfig'
const InventoryQueryCtrl = require('./InventoryQueryCtrl')
const declareInventoryQueryCtrl = require('./declareInventoryQueryCtrl')
import receiveTicketModal from './receiveTicketModal'
import statusUpdatesModal from './statusUpdatesModal'
export default angular
    .module('outputManage.stock.InventoryQuery', [])
    .config([
        '$stateProvider',
        ($stateProvider) => {
            Object.keys(routers).forEach((router) => {
                $stateProvider.state(routers[router].state, routers[router].config)
            })
        },
    ])
    .value('IQfieldConfig', fieldConfig)
    .controller('InventoryQueryCtrl', InventoryQueryCtrl.default)
    .controller('receiveTicketModal', receiveTicketModal)
    .controller('statusUpdatesModal', statusUpdatesModal)
    .controller('declareInventoryQueryCtrl', declareInventoryQueryCtrl).name



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/InventoryQuery/index.js